<template>
  <div>
    <div class="form-switch">
      <input
        :id="`singleSwitch-${id}`"
        type="checkbox"
        :class="[`form-switch__field`, checked && `form-switch__field--checked`]"
        :name="`singleSwitch-${id}`"
        :checked="checked"
        :disabled="disabled"
        required
        @click="onClick()"
      />
      <label
        :class="[
          `form-switch__label`,
          hover && `hover`,
          active && `active`,
          focus && `focus`,
          switchPosition === 'vertical' ? 'form-switch__label--vertical' : '',
        ]"
        :for="`singleSwitch-${id}`"
      >{{ label }}</label>
    </div>
    <p
      v-if="errorMessage"
      class="form-label form-label--error form-label--error--active"
    >{{ errorMessage }}</p>
    <div
      v-if="helpMessage"
      :class="[`form-help`, helpMessagePosition === `right` && `text-right`]"
    >{{ helpMessage }}</div>
  </div>
</template>

<script>
export default {
  name: "SwitchStandard",
  props: {
    label: {
      type: String,
      required: true,
    },
    errorMessage: {
      type: String,
      required: true,
    },
    helpMessage: {
      type: String,
      required: true,
    },
    helpMessagePosition: {
      type: String,
      required: true,
    },
    checked: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
    hover: {
      type: Boolean,
      required: true,
    },
    active: {
      type: Boolean,
      required: true,
    },
    focus: {
      type: Boolean,
      required: true,
    },
    id: {
      type: String,
      default: "switch"
    },
    switchPosition: {
      type: String,
      default: "horizontal"
    }
  },
  methods: {
    onClick() {
      this.$emit("onClick", !this.checked);
    },
  },
};
</script>

<style lang="scss" scoped>
.form-switch__label--vertical:before {
  top: 32px;
  right: unset;
  left: 0;
}
.form-switch__label--vertical:after {
  top: 34px;
  right: unset;
  left: 2px;
}

.theme--light .form-switch__field:checked + .form-switch__label--vertical:after {
    right: unset;
    left: 20px;
    top: 34px;
}
</style>